/** @format */
import {OrderBasicDetails} from 'frontier-components';
import {Table} from '@sttark/design-system';
import {DateOnly, Currency} from 'frontier-utilities';
import NumberFormat from 'react-number-format';
import {ActionColumn} from './action_column';
import {NameColumn} from './name_column';
import React from 'react';

// styles
import './orders_list.scss';
import {DesignsList} from 'frontier/account/components/reorder_orders/designs_grouped_table/designs_table/designs_list';

const columns = [
    {
        key: 'name',
        title: 'Name',
        index: 'name'
    },
    {
        key: 'type',
        title: 'Type',
        index: 'type'
    },
    {
        key: 'qty',
        title: 'Qty',
        index: 'qty'
    },
    {
        key: 'description',
        title: 'Description',
        index: 'description'
    },
    {
        key: 'data',
        title: 'Date',
        index: 'date'
    },
    {
        key: 'quoted_cost',
        title: 'Quoted Cost',
        index: 'quoted_cost'
    },
    {
        key: 'action',
        title: '',
        index: 'action'
    }
];

export const OrdersList = props => {
    const {orders} = props;

    return (
        <div className="saved-orders-list-table-active-00fb">
            <Table
                columns={columns}
                rows={orders.map(order => {
                    return {
                        name: <NameColumn order={order} />,
                        type: (
                            <p className="saved-orders-list-table-active-00fb__column--type">
                                {order.product_type_label}
                            </p>
                        ),
                        qty: (
                            <p className="saved-orders-list-table-active-00fb__column--qty">
                                <NumberFormat
                                    value={order.duplex_aware_total_qty}
                                    thousandSeparator={true}
                                    displayType="text"
                                />
                            </p>
                        ),
                        description: (
                            <div className="saved-orders-list-table-active-00fb__column--details">
                                <OrderBasicDetails order={order} />
                            </div>
                        ),
                        date: <DateOnly>{new Date(order.modified)}</DateOnly>,
                        quoted_cost: (
                            <Currency
                                value={order.quoted_total}
                                style={{fontSize: '16px'}}
                                thousandSeparator={true}
                            />
                        ),
                        action: <ActionColumn order={order} />,
                        key: order.id,
                        renderData: order
                    };
                })}
                isExpandable>
                <DesignsList />
            </Table>
        </div>
    );
};
